import { Box, Theme, useTheme } from '@mui/material';
import { ReactComponent as MissingIcon } from '../../../assets/icons/Doc Not Found.svg';
import { EntityLabel } from '@esg/esg-global-types';
import { MinorHeading } from '../typography/PrimaryTypography';

interface DataGridNoRowsProps {
  missing_label: EntityLabel;
}

/**
 * Reusable template for datagrid without rows to display.
 * @param {EntityLabel} missing_label Label of missing entity to show plural for.
 * @returns {JSX.Element}
 */
const DataGridNoRows = ({ missing_label }: DataGridNoRowsProps) => {
  const theme: Theme = useTheme();
  return (
    <Box
      sx={{
        height: 100,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'primary.main',
        my: 2
      }}
    >
      <MissingIcon
        height={50}
        fill={theme.palette.primary.main}
        stroke={theme.palette.primary.main}
      />
      <MinorHeading>No {missing_label.many} found.</MinorHeading>
    </Box>
  );
};

export default DataGridNoRows;
